import * as React from "react";
import { ArrowRight } from "lucide-react";
import { motion, useInView } from "framer-motion";
import { Card, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Carousel, CarouselContent, CarouselItem } from "@/components/ui/carousel";
import { cn } from "@/lib/utils";
const features = [{
  title: "Studio Universitario",
  items: "Visto per Studio|Visto per Iscrizione Universitaria|Visto per Master e Specializzazione|Visto per Dottorato di Ricerca|Visto per Alta Formazione (AFAM)",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1663124/img/card 1.png"
}, {
  title: "Ricerca e Formazione Accademica",
  items: "Visto per Ricerca|Visto per Assegni di Ricerca|Visto per Visiting Researcher|Visto per Corsi di Perfezionamento",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1663124/img/card 2.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1663124/img/card 2.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1663124/img/card 2.png-wvc-sizes"
}, {
  title: "Programmi Internazionali e Exchange",
  items: "Visto per Programmi Exchange|Visto per Programmi Erasmus|Visto per Mobilità Studentesca|Visto per Scambi Culturali e Accademici|Visto per Programmi Educativi Internazionali",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1663124/img/card 3.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1663124/img/card 3.png",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1663124/img/card 3.png"
}, {
  title: "Tirocini e Percorsi Professionali",
  items: "Visto per Tirocinio Formativo|Visto per Internship Internazionale",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1663124/img/card 4.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1663124/img/card 4.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1663124/img/card 4.png-wvc-sizes"
}];
export default function PracticeManagementReimagined() {
  const carouselRef = React.useRef(null);
  const inView = useInView(carouselRef, {
    once: false,
    amount: 0.2
  });
  return <section data-section-id="223262" id="servizi-per-studenti" className="bg-background text-foreground py-24 px-4 md:px-8 overflow-hidden relative">
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[800px] h-[400px] bg-secondary/10 rounded-lg blur-[100px] pointer-events-none" />

      <div className="max-w-7xl mx-auto relative z-10">
        <div className="text-center mb-16 max-w-3xl mx-auto">
          <h2 className="text-3xl md:text-5xl font-bold font-serif mb-6 tracking-tight text-foreground">
            Servizi per Studenti
          </h2>
          <p className="text-lg text-muted-foreground font-default">
            Soluzioni integrate per il percorso accademico internazionale. Dalla gestione dei visti al supporto burocratico ministeriale, accompagniamo ogni studente nel suo futuro in Italia.
          </p>
        </div>

        <div ref={carouselRef}>
          <Carousel opts={{
          align: "start",
          loop: false
        }} className="w-full">
            <CarouselContent className="-ml-4 md:-ml-6">
              {features.map((feature, i) => <CarouselItem key={i} data-index={i} className="pl-4 md:pl-6 md:basis-1/4">
                  <motion.div initial={{
                opacity: 0,
                translateY: 40
              }} animate={inView ? {
                opacity: 1,
                translateY: 0,
                filter: 'grayscale(0%)'
              } : {
                filter: 'grayscale(100%)'
              }} transition={{
                duration: 0.7,
                delay: i * 0.2
              }} className="h-full">
                    <Card className={cn("h-full bg-white/20 backdrop-blur-md border border-white/40 transition-all duration-500 hover:-translate-y-5 hover:shadow-3xl hover:shadow-white/10 group", i === 2 && "hover:border-cyan-400/50 hover:shadow-[0_0_30px_rgba(34,211,238,0.3)]")}>
                      <CardHeader className="p-8">
                        <div className={cn("flex items-center justify-center mb-6 transition-all duration-500 overflow-hidden mx-auto", i === 0 || i === 1 || i === 2 || i === 3 ? "size-48" : "size-20", i === 0 && "rounded-3xl bg-white/10 shadow-[0_0_20px_rgba(255,255,255,0.2)]", i === 1 && "bg-white/10", i === 2 && "rounded-lg bg-gradient-to-br from-cyan-500/20 to-purple-500/20 border border-cyan-400/30 group-hover:shadow-[0_0_15px_rgba(34,211,238,0.5)]", i === 3 && "rounded-3xl bg-white/10 shadow-[0_0_20px_rgba(255,255,255,0.2)]")}>
                          {i === 0 || i === 3 ? <img src={feature.image} data-wvc-srcset={feature.image === "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1663124/img/card 1.png" ? "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1663124/img/card 1.png-wvc-srcset" : "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1663124/img/card 4.png-wvc-srcset"} data-wvc-sizes={feature.image === "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1663124/img/card 1.png" ? "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1663124/img/card 1.png-wvc-sizes" : "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1663124/img/card 4.png-wvc-sizes"} alt={feature.title} className="size-48 mx-auto rounded-3xl object-cover" loading="lazy" decoding="async" /> : <img src={feature.image} {...feature.srcset && {
                        "data-wvc-srcset": feature.srcset
                      }} {...feature.sizes && {
                        "data-wvc-sizes": feature.sizes
                      }} alt={feature.title} className={cn("size-full object-cover", "rounded-lg")} loading="lazy" decoding="async" />}
                        </div>
                        <CardTitle className="font-serif font-bold text-2xl mb-3 text-foreground text-center">
                          {feature.title}
                        </CardTitle>
                        <CardDescription className="text-base leading-relaxed text-muted-foreground font-default font-light">
                          <div className="flex flex-col gap-2 items-center">
                            {feature.items.split('|').map((item, idx) => <div key={idx} className={cn("flex items-center gap-2 group/item w-full", "justify-start")}>
                                <span className="group-hover/item:text-secondary transition-colors duration-300 shrink-0">
                                  <ArrowRight className="size-4 text-secondary shrink-0" />
                                </span>
                                <span className={cn("text-sm", "text-left")}>{item}</span>
                              </div>)}
                          </div>
                        </CardDescription>
                      </CardHeader>
                    </Card>
                  </motion.div>
                </CarouselItem>)}
            </CarouselContent>
          </Carousel>
        </div>
      </div>
    </section>;
}